import { render, staticRenderFns } from "./mainController.vue?vue&type=template&id=d0a90db0&scoped=true"
import script from "./mainController.vue?vue&type=script&lang=js"
export * from "./mainController.vue?vue&type=script&lang=js"
import style0 from "./mainController.vue?vue&type=style&index=0&id=d0a90db0&prod&lang=scss"
import style1 from "./mainController.vue?vue&type=style&index=1&id=d0a90db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a90db0",
  null
  
)

export default component.exports